import { render, staticRenderFns } from "./UploadTemplate.vue?vue&type=template&id=3cf790cb&scoped=true"
import script from "./UploadTemplate.vue?vue&type=script&lang=js"
export * from "./UploadTemplate.vue?vue&type=script&lang=js"
import style0 from "./UploadTemplate.vue?vue&type=style&index=0&id=3cf790cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf790cb",
  null
  
)

export default component.exports